import orderHistoryAddProductsCollectData from 'account/orderHistory/orderHistoryAddProducts/orderHistoryAddProductsCollectData';
import { Events } from 'global/constants';

const { events } = window.od;

const orderHistoryAddToListSubmit = () => {
	const shoppingListsNode = document.querySelector('[data-id="shoppingLists"]');
	const newListFormNode = document.querySelector(
		'[data-id="addToListNewListForm"]',
	);
	const newListBtn = document.querySelector('[data-id="addToListNewListBtn"]');

	if (shoppingListsNode) {
		shoppingListsNode.addEventListener('click', handleAddToExistingList);
	}
	if (newListFormNode) {
		newListFormNode.addEventListener('submit', handleAddToNewList);
	}
	if (newListBtn) {
		newListBtn.addEventListener('click', handleAddToNewList);
	}
};

const handleAddToExistingList = e => {
	const listNode = e.target.hasAttribute('data-shopping-list')
		? e.target
		: e.target.closest('[data-shopping-list]');
	if (listNode) {
		const shoppingListName = getExistingListName(listNode);
		addToList(shoppingListName);
	}
};

const handleAddToNewList = e => {
	e.preventDefault();
	const newListInput = document.querySelector(
		'[data-id="addToListNewListInput"]',
	);
	if (!newListInput) {
		return;
	}

	const shoppingListName = getNewListName(newListInput);
	if (shoppingListName) {
		addToList(shoppingListName);
	}
};

const getExistingListName = listNode => {
	const shoppingListName = listNode.getAttribute('data-list-id');
	return shoppingListName;
};

const getNewListName = inputElement => {
	return inputElement.value;
};

const addToList = shoppingListName => {
	const cartEntries = getAddProductsData();
	const requestData = {
		shoppingListName,
		cartEntries,
	};
	publishEvent(requestData);
	removeListener();
};

const getAddProductsData = () => {
	const products = document.querySelectorAll('[data-product-row-add-product]');
	const { cartEntries } = orderHistoryAddProductsCollectData(products);
	return cartEntries;
};

const publishEvent = data => {
	events.publish(Events.ADD_TO_LIST_SUBMIT_END, data);
};

const removeListener = () => {
	const shoppingListsNode = document.querySelector('[data-id="shoppingLists"]');
	if (shoppingListsNode) {
		shoppingListsNode.removeEventListener('click', handleAddToExistingList);
	}
};

export {
	orderHistoryAddToListSubmit as default,
	handleAddToExistingList,
	handleAddToNewList,
	getExistingListName,
	getNewListName,
	getAddProductsData,
	publishEvent,
	removeListener,
};
